import React from 'react';
import { Image, Shimmer } from 'react-shimmer'

export default class SearchArticleListItem extends React.Component {
  render() {
    return (
      <a className="search-results__item" href={this.props.article.url}>
        <Image
          src={this.props.article.image_url}
          fallback={<Shimmer width={56} height={40} />}
          errorFallback={() => (
            <Shimmer width={56} height={40} />
          )}
          NativeImgProps={{ className: 'search-results__thumbnail', alt: this.props.article.title }}
        />
        <div className="search-results__item-content">
          <div className="search-results__item-title">{this.props.article.title}</div>
          <div className="search-results__item-subtitle">{this.props.article.content}</div>
        </div>
      </a>
    );
  }
}
